<template>
  <div class="examinedStudent">
    <div class="student">
      <VideoReceiver
        :desktop="true"
        :remote-client-id="`student:${student.id}`"
      :token="student.p2p_token"/>
      <div class="info">
        <div class="name">
          {{ fullName(student) }}
        </div>
      </div>
    </div>
    <ExaminationPaper
      :examinationPaper="studentPaper"/>
  </div>
</template>

<script>
import {
  PREPARING,
  FINISHED
} from '@/config'

import VideoReceiver from '@/components/VideoReceiver'
import ExaminationPaper from '@/components/ExaminationPaper.vue'

import { fullName } from '@/utils/utils.format'

export default {
  name: 'ExaminedStudent',
  props: {
    student: Object,
    getPaper: Function,
    updateStatus: Function,
  },
  components: {
    VideoReceiver,
    ExaminationPaper
  },
  data () {
    return {
      PREPARING,
      FINISHED,
    }
  },
  methods: {
    fullName
  },
  computed: {
    studentPaper () {
      return this.getPaper(this.student.examination_paper)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.examinedStudent {
  padding: 32px 0;
  border-top: 2px solid $accent;
}

.student {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;

  .info {
    margin-top: 24px;
    line-height: 32px;
    .name {
      font-size: 24px;
    }
  }
}

</style>
